import styled from 'foundations-theming/utils';
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo, useState, useEffect, useCallback } from 'react';
import PortalIdParser from 'PortalIdParser';
import getIn from 'transmute/getIn';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getIsTabCall } from 'calling-ui-library/utils/widgetDetailsOperators';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createInitiateOutboundCallMessage } from 'calling-lifecycle-messages/deviceEventCreators';
import { getAccountTypeFromPhoneNumber } from 'calling-ui-library/utils/getAccountTypeFromPhoneNumber';
import { getCallTabUrl } from '../../utils/getCallTabUrl';
import { INITIATE_OUTBOUND_CALL_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
import { callingWindowUrl } from 'calling-lifecycle-internal/utils/urlUtils';
import { getPropertyName, getObjectId, getObjectTypeId, getPhoneNumberProperties, getMetadata } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
import CallSettingsIcon from 'calling-ui-library/callee-select/components/CallSettingsIcon';
import InboundCallingTracker from 'calling-lifecycle-usage-tracker/inboundCallingTracker';

// @ts-expect-error not typed
import CurrentSettingsInfoActivityCreator from './CurrentSettingsInfoActivityCreator';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getIsProviderHubSpot, getIsTwilioBasedCallProvider } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { logCallingError } from 'calling-error-reporting/report/error';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import { ACTIVITY_CREATOR } from 'calling-internal-common/constants/appIdentifiers';
import { PhoneNumberSources } from 'calling-internal-common/constants/PhoneNumberSources';
import { hasPaidSeatAccess } from 'calling-orchestration-shared-library/hub-info/utils/hasCallingFeature';
import { isProviderSwitchingEnabled } from 'calling-internal-common/utils/isProviderSwitchingEnabled';
import openCallingWidget from 'calling-global-api/methods/openCallingWidget';
import { getHubSpotCallingEnabled, getInstalledCallingApplications, getPhoneNumbers } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import ChangeProviderButtonWrapper from './ChangeProviderButtonWrapper';
import { CALLEE_NUMBERS } from 'calling-ui-library/calling-remote-redesign/constants/changeProviderButtonLocations';
import { Spacer } from 'foundations-components/components/Spacer';
import { getIsThirdPartyCallingPopoverInUse } from 'calling-internal-common/utils/isThirdPartyCallingPopoverInUse';
import { getHasMultipleProviders } from '../utils/getHasMultipleProviders';
import ProviderName from './ProviderName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CallNotesButtonWrapper",
  componentId: "vqdwhh-0"
})(["position:sticky;bottom:0;background:", ";border-style:solid;border-width:", ";border-color:", ";"], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => `${theme.borderWidth['200']} ${theme.borderWidth['0']} ${theme.borderWidth['0']} ${theme.borderWidth['0']}`, ({
  theme
}) => theme.color['do-not-use-koala']);
const CalleeSelectDropdownWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CalleeSelectDropdownWrapper",
  componentId: "vqdwhh-1"
})(["max-height:400px;overflow:auto;"]);
const CallSettingsNumbersActivityCreator = props => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeConnectionId = getStandaloneConnectionId(widgetDetails);
  const activeCallTabOpen = Boolean(activeConnectionId);
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const [selectedFromNumber, setSelectedFromNumber] = useState(props.defaultFromNumber);
  useEffect(() => {
    setSelectedFromNumber(props.defaultFromNumber);
  }, [props.defaultFromNumber]);
  const openCallTabAndStartOutboundCall = ({
    callableObject,
    toNumber,
    fromNumber,
    accountType,
    prospectingQueueItemId
  }) => {
    const portalId = PortalIdParser.get();
    const trimmedCallableObject = {
      objectId: getObjectId(callableObject),
      objectTypeId: getObjectTypeId(callableObject),
      crmObjectSubscriptionStatus: getIn(['crmObjectSubscriptionStatus'], callableObject)
    };
    if (props.isUngatedForRedesign) {
      const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${CallSource.OUTBOUND_DIALER}&requireContactOrCompany=true&prospectingQueueItemId=${prospectingQueueItemId}`;
      window.open(callingWindowUrl(PortalIdParser.get() || '', queryString), 'calling-window', 'menubar=no,resizable=no,scrollbars=yes,location=no,width=400,height=600');
    } else {
      const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${CallSource.CRM}&accountType=${accountType}&requireContactOrCompany=true&prospectingQueueItemId=${prospectingQueueItemId}`;
      window.open(getCallTabUrl(portalId, queryString), 'calling-window', 'menubar=no,resizable=yes,scrollbars=no,location=no,width=740,height=750');
    }
  };
  const startThirdPartyOutboundCall = useCallback(({
    numberIdentifier,
    callableObject
  }) => {
    const {
      gates,
      selectedCallProvider,
      onCallButtonClick,
      onLegacyOutboundCallStart
    } = props;
    if (!getIsThirdPartyCallingPopoverInUse(gates, selectedCallProvider) && onLegacyOutboundCallStart) {
      onLegacyOutboundCallStart();
    }
    const phoneNumberProperties = getPhoneNumberProperties(callableObject);
    const numberPropertyName = getPropertyName(numberIdentifier);
    openCallingWidget({
      toSubject: {
        objectId: getObjectId(callableObject),
        objectTypeId: getObjectTypeId(callableObject),
        phoneNumberProperties,
        numberPropertyName
      },
      startCall: true,
      callingProvider: selectedCallProvider
    });
    onCallButtonClick();
  }, [props]);
  const startOutboundCall = ({
    numberIdentifier,
    callableObject
  }) => {
    if (!getIsTwilioBasedCallProvider(props.selectedCallProvider)) {
      startThirdPartyOutboundCall({
        numberIdentifier,
        callableObject
      });
      return;
    }
    const numberPropertyName = getPropertyName(numberIdentifier);
    const phoneNumberProperties = getPhoneNumberProperties(callableObject);
    const propertyToCall = getIn([numberPropertyName], phoneNumberProperties) || null;
    const phoneNumberMetadata = propertyToCall && getMetadata(propertyToCall);
    const toNumber = phoneNumberMetadata.toNumberString;
    const fromNumber = getIn(['phoneNumber'], selectedFromNumber);
    const fromNumberSource = getIn(['source'], selectedFromNumber);
    const accountType = getAccountTypeFromPhoneNumber(selectedFromNumber);
    const callProvider = fromNumberSource === PhoneNumberSources.CONNECT_NUMBER ? 'Twilio' : 'Hubspot';
    const isChannelConnectedFromNumber = !!getIn(['workspaceIdAndType'], selectedFromNumber);
    if (fromNumber) {
      CommunicatorLogger.log('callUsage_startCall', {
        action: 'start call',
        callMedium: 'CALLING_PAGE_UI',
        provider: callProvider,
        source: ACTIVITY_CREATOR,
        phoneNumberType: fromNumberSource,
        isChannelConnectedFromNumber
      });
      InboundCallingTracker.trackCallTabStartOutboundCall({
        appIdentifier: props.appIdentifier
      });
      if (activeCallTabOpen) {
        sendCrossTabMessage(createInitiateOutboundCallMessage({
          destinationConnectionId: activeConnectionId,
          callableObject: callableObject.toJS(),
          toNumber,
          fromNumber,
          source: CallSource.CRM,
          accountType,
          // not needed for redesign
          requireContactOrCompany: true,
          prospectingQueueItemId: props.prospectingQueueItemId
        })).catch(error => {
          logCallingError({
            error,
            tags: {
              requestName: 'sendCrossTabMessage - initiate outbound call'
            }
          });
        });
      } else {
        openCallTabAndStartOutboundCall({
          callableObject,
          toNumber,
          fromNumber,
          accountType,
          prospectingQueueItemId: props.prospectingQueueItemId
        });
      }
      props.onCallButtonClick();
    }
  };
  const {
    asyncCalleeOmnibus,
    asyncSettingsOmnibus,
    widgetState,
    selectedCallProvider,
    scopes,
    limits,
    gates
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const settingsOmnibusData = getData(asyncSettingsOmnibus);
  const installedCallingApplications = getInstalledCallingApplications(settingsOmnibusData);
  const shouldShowActiveCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isActiveCallTab = getIsTabCall(widgetDetails);
  const isThirdPartyActive = getIn(['isThirdPartyActive'], widgetState);
  const isFreeCallingAndHS = !hasPaidSeatAccess() && getIsProviderHubSpot(selectedCallProvider);
  const isCallTabActive = (getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus)) && isActiveCallTab;
  const disabledTooltipMessage = isFreeCallingAndHS ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isCallTabActive ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  const isUngatedForProviderSwitching = useMemo(() => isProviderSwitchingEnabled(gates), [gates]);
  const showCurrentSettingsInfo = useMemo(() => {
    return !isUngatedForProviderSwitching || getIsTwilioBasedCallProvider(selectedCallProvider);
  }, [selectedCallProvider, isUngatedForProviderSwitching]);
  const hasMultipleProviders = useMemo(() => getHasMultipleProviders({
    installedCallingApplicationsLength: (installedCallingApplications === null || installedCallingApplications === void 0 ? void 0 : installedCallingApplications.length) || 0,
    fromNumbers: getPhoneNumbers(settingsOmnibusData),
    isHubSpotEnabled: getHubSpotCallingEnabled(selectedCallProvider)
  }), [installedCallingApplications, settingsOmnibusData, selectedCallProvider]);
  const showProviderName = useMemo(() => {
    return isUngatedForProviderSwitching && !getIsTwilioBasedCallProvider(selectedCallProvider) && hasMultipleProviders;
  }, [isUngatedForProviderSwitching, selectedCallProvider, hasMultipleProviders]);
  const showChangeProviderButton = useMemo(() => {
    return isUngatedForProviderSwitching && hasMultipleProviders;
  }, [isUngatedForProviderSwitching, hasMultipleProviders]);
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: props.appIdentifier,
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      CallSettingsIcon: CallSettingsIcon,
      disabledTooltipMessage: disabledTooltipMessage
    }), showProviderName && /*#__PURE__*/_jsx(ProviderName, {
      selectedCallProvider: selectedCallProvider
    }), showCurrentSettingsInfo &&
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(CallNotesButtonWrapper, {
      children: /*#__PURE__*/_jsx(CurrentSettingsInfoActivityCreator, {
        asyncSettingsOmnibus: asyncSettingsOmnibus,
        disabled: isThirdPartyActive || shouldShowActiveCallState,
        limits: limits,
        scopes: scopes,
        onSelectFromNumber: setSelectedFromNumber,
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber,
        showFromNumberDropdown: getIsTwilioBasedCallProvider(selectedCallProvider) || !isProviderSwitchingEnabled(gates)
      })
    }), showChangeProviderButton && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChangeProviderButtonWrapper, {
        providerName: selectedCallProvider.name,
        location: CALLEE_NUMBERS
      }), /*#__PURE__*/_jsx(Spacer, {
        space: "100"
      })]
    })]
  });
};
export default CallSettingsNumbersActivityCreator;